import Footer from "../components/footer";
import Header from "../components/header";

export default function Home3(){
    return(
        <>
        <Header/>
        <>
  {/* banner starts */}
  <section className="banner overflow-hidden">
    <div className="banner-main">
      <div className="banner-image">
        <div className="video-banner">
          <video autoPlay="" muted="" loop="" id="vid" className="w-100">
            <source src="images/tour.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="dot-overlay" />
      </div>
      <div className="banner-content">
        <div className="entry-meta mb-0">
          <span className="entry-category">
            <a href="tour-grid.html" className="white">
              {" "}
              Travelin
            </a>
          </span>
        </div>
        <h1 className="mb-0">
          <a href="tour-single.html" className="white">
            Create Your Journey Joyfull Through Us
          </a>
        </h1>
      </div>
    </div>
  </section>
  {/* banner ends */}
  {/* about-us starts */}
  <section className="about-us p-0">
    <div className="container">
      <div className="about-image-box">
        <div className="row d-flex align-items-center justify-content-between">
          <div className="col-lg-5 mb-4 pe-lg-4">
            {/* form main starts */}
            <div className="form-main mt-minus">
              <div className="form-content rounded overflow-hidden">
                <h3 className="form-title text-center p-3 white bg-theme mb-0 rounded-top">
                  Find a Places
                </h3>
                <div className="book-form px-4 py-5">
                  <div className="form-group mb-2">
                    <div className="input-box">
                      <select className="niceSelect">
                        <option value={1}>Destination</option>
                        <option value={2}>Argentina</option>
                        <option value={3}>Belgium</option>
                        <option value={4}>Canada</option>
                        <option value={5}>Denmark</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group mb-2">
                    <div className="input-box">
                      <input type="date" name="date" />
                    </div>
                  </div>
                  <div className="form-group mb-2">
                    <div className="input-box">
                      <select className="niceSelect">
                        <option value={1}>Travel Type</option>
                        <option value={2}>City Tour</option>
                        <option value={3}>Family Tour</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group mb-2">
                    <div className="input-box">
                      <select className="niceSelect">
                        <option value={1}>Tour Duration</option>
                        <option value={2}>5 days</option>
                        <option value={3}>7 Days</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group text-center">
                    <a href="#" className="nir-btn w-100">
                      <i className="fa fa-search mr-2" /> Search Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* form main ends */}
          </div>
          <div className="col-lg-7 mb-4 ps-lg-4">
            <div className="about-content text-center text-lg-start mb-4 mt-10">
              <h4 className="theme d-inline-block mb-0">Get To Know Us</h4>
              <h2>Explore All Tour of the world with us.</h2>
              <p className="border-b mb-2 pb-2">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </p>
              <div className="about-listing">
                <ul className="d-flex justify-content-between">
                  <li>
                    <i className="icon-location-pin theme" /> Tour Guide
                  </li>
                  <li>
                    <i className="icon-briefcase theme" /> Friendly Price
                  </li>
                  <li>
                    <i className="icon-folder theme" /> Reliable Tour Package
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="white-overlay" />
  </section>
  {/* about-us ends */}
  {/* top Destination starts */}
  <section
    className="trending pb-0 pt-6"
    style={{
      backgroundImage: "url(images/shape-1.png)",
      backgroundPosition: "center"
    }}
  >
    <div className="container">
      <div className="section-title mb-6 w-50 mx-auto text-center">
        <h4 className="mb-1 theme1">Top Destinations</h4>
        <h2 className="mb-1">
          Explore <span className="theme">Top Destinations</span>
        </h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore.
        </p>
      </div>
      <div className="row align-items-center">
        <div className="col-lg-5 mb-4">
          <div className="trend-item1">
            <div className="trend-image position-relative rounded">
              <img src="images/destination/destination1.jpg" alt="image" />
              <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                <div className="trend-content-title">
                  <h5 className="mb-0">
                    <a href="tour-grid.html" className="theme1">
                      England
                    </a>
                  </h5>
                  <h3 className="mb-0 white">London</h3>
                </div>
                <span className="white bg-theme p-1 px-2 rounded">
                  15 Tours
                </span>
              </div>
              <div className="color-overlay" />
            </div>
          </div>
        </div>
        <div className="col-lg-7">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
              <div className="trend-item1">
                <div className="trend-image position-relative rounded">
                  <img src="images/destination/destination17.jpg" alt="image" />
                  <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                    <div className="trend-content-title">
                      <h5 className="mb-0">
                        <a href="tour-grid.html" className="theme1">
                          Italy
                        </a>
                      </h5>
                      <h3 className="mb-0 white">Caspian Valley</h3>
                    </div>
                    <span className="white bg-theme p-1 px-2 rounded">
                      18 Tours
                    </span>
                  </div>
                  <div className="color-overlay" />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
              <div className="trend-item1">
                <div className="trend-image position-relative rounded">
                  <img src="images/destination/destination14.jpg" alt="image" />
                  <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                    <div className="trend-content-title">
                      <h5 className="mb-0">
                        <a href="tour-grid.html" className="theme1">
                          Tokyo
                        </a>
                      </h5>
                      <h3 className="mb-0 white">Japan</h3>
                    </div>
                    <span className="white bg-theme p-1 px-2 rounded">
                      21 Tours
                    </span>
                  </div>
                  <div className="color-overlay" />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
              <div className="trend-item1">
                <div className="trend-image position-relative rounded">
                  <img src="images/destination/destination15.jpg" alt="image" />
                  <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100">
                    <div className="trend-content-title">
                      <h5 className="mb-0">
                        <a href="tour-grid.html" className="theme1">
                          Moscow
                        </a>
                      </h5>
                      <h3 className="mb-0 white">Russia</h3>
                    </div>
                    <span className="white bg-theme p-1 px-2 rounded">
                      15 Tours
                    </span>
                  </div>
                  <div className="color-overlay" />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
              <div className="trend-item1">
                <div className="trend-image position-relative rounded">
                  <img src="images/destination/destination16.jpg" alt="image" />
                  <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                    <div className="trend-content-title">
                      <h5 className="mb-0">
                        <a href="tour-grid.html" className="theme1">
                          Florida
                        </a>
                      </h5>
                      <h3 className="mb-0 white">America</h3>
                    </div>
                    <span className="white bg-theme p-1 px-2 rounded">
                      32 Tours
                    </span>
                  </div>
                  <div className="color-overlay" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* top Destination ends */}
  {/* Counter */}
  <section className="counter-main pt-6">
    <div className="container">
      <div className="counter p-4 pb-0 box-shadow bg-white rounded m-0">
        <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
            <div className="counter-item border-end pe-4 d-flex align-items-center">
              <i className="icon-clock bg-theme p-3 rounded me-3 white fs-4" />
              <div className="counter-content">
                <h2 className="value mb-0">20</h2>
                <span className="m-0">Years Experiences</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
            <div className="counter-item border-end pe-4 d-flex align-items-center">
              <i className="icon-magnifier bg-theme p-3 rounded me-3 white fs-4" />
              <div className="counter-content">
                <h2 className="value mb-0">530</h2>
                <span className="m-0">Tour Packages</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
            <div className="counter-item border-end pe-4 d-flex align-items-center">
              <i className="icon-user-following bg-theme p-3 rounded me-3 white fs-4" />
              <div className="counter-content">
                <h2 className="value mb-0">850</h2>
                <span className="m-0">Happy Customers</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
            <div className="counter-item d-flex align-items-center">
              <i className="icon-trophy bg-theme p-3 rounded me-3 white fs-4" />
              <div className="counter-content">
                <h2 className="value mb-0">320</h2>
                <span className="m-0">Award Winning</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* End Counter */}
  {/* best tour Starts */}
  <section className="trending p-0">
    <div className="container">
      <div className="section-title text-center w-75 mx-auto mb-6">
        <h4 className="mb-1 theme1">Top Pick</h4>
        <h2 className="mb-1">
          Best <span className="theme">Tour Packages</span>
        </h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore.
        </p>
      </div>
      <div className="trend-box">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
            <div className="trend-item rounded box-shadow">
              <div className="trend-image position-relative">
                <img
                  src="images/trending/trending2.jpg"
                  alt="image"
                  className=""
                />
                <div className="color-overlay" />
              </div>
              <div className="trend-content p-4 pt-5 position-relative">
                <div className="trend-meta bg-theme white px-3 py-2 rounded">
                  <div className="entry-author">
                    <i className="icon-calendar" />
                    <span className="fw-bold"> 9 Days Tours</span>
                  </div>
                </div>
                <h5 className="theme mb-1">
                  <i className="flaticon-location-pin" /> Croatia
                </h5>
                <h3 className="mb-1">
                  <a href="tour-grid.html">Piazza Castello</a>
                </h3>
                <div className="rating-main d-flex align-items-center pb-2">
                  <div className="rating">
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                  </div>
                  <span className="ms-2">(12)</span>
                </div>
                <p className="border-b pb-2 mb-2">
                  Duis aute irure dolor in reprehenderit in voluptate velit esse
                  cillum
                </p>
                <div className="entry-meta">
                  <div className="entry-author d-flex align-items-center">
                    <p className="mb-0">
                      <span className="theme fw-bold fs-5"> $170.00</span> | Per
                      person
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
            <div className="trend-item box-shadow rounded">
              <div className="trend-image position-relative">
                <img src="images/trending/trending3.jpg" alt="image" />
                <div className="color-overlay" />
              </div>
              <div className="trend-content p-4 pt-5 position-relative">
                <div className="trend-meta bg-theme white px-3 py-2 rounded">
                  <div className="entry-author">
                    <i className="icon-calendar" />
                    <span className="fw-bold"> 9 Days Tours</span>
                  </div>
                </div>
                <h5 className="theme mb-1">
                  <i className="flaticon-location-pin" /> Greece
                </h5>
                <h3 className="mb-1">
                  <a href="tour-grid.html">Santorini, Oia</a>
                </h3>
                <div className="rating-main d-flex align-items-center pb-2">
                  <div className="rating">
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                  </div>
                  <span className="ms-2">(38)</span>
                </div>
                <p className="border-b pb-2 mb-2">
                  Duis aute irure dolor in reprehenderit in voluptate velit esse
                  cillum
                </p>
                <div className="entry-meta">
                  <div className="entry-author d-flex align-items-center">
                    <p className="mb-0">
                      <span className="theme fw-bold fs-5"> $180.00</span> | Per
                      person
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="trend-item box-shadow rounded">
              <div className="trend-image position-relative">
                <img src="images/trending/trending4.jpg" alt="image" />
                <div className="color-overlay" />
              </div>
              <div className="trend-content p-4 pt-5 position-relative">
                <div className="trend-meta bg-theme white px-3 py-2 rounded">
                  <div className="entry-author">
                    <i className="icon-calendar" />
                    <span className="fw-bold"> 9 Days Tours</span>
                  </div>
                </div>
                <h5 className="theme mb-1">
                  <i className="flaticon-location-pin" /> Maldives
                </h5>
                <h3 className="mb-1">
                  <a href="tour-grid.html">Hurawalhi Island</a>
                </h3>
                <div className="rating-main d-flex align-items-center pb-2">
                  <div className="rating">
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                    <span className="fa fa-star checked" />
                  </div>
                  <span className="ms-2">(18)</span>
                </div>
                <p className="border-b pb-2 mb-2">
                  Duis aute irure dolor in reprehenderit in voluptate velit esse
                  cillum
                </p>
                <div className="entry-meta">
                  <div className="entry-author d-flex align-items-center">
                    <p className="mb-0">
                      <span className="theme fw-bold fs-5"> $260.00</span> | Per
                      person
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12 text-center">
            <a href="#" className="nir-btn">
              View All Packages
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* best tour Ends */}
  {/* Last Minute Deal Starts */}
  <section
    className="trending pb-6"
    style={{ backgroundImage: "url(images/shape4.png)" }}
  >
    <div className="container">
      <div className="row align-items-center justify-content-between mb-6">
        <div className="col-lg-7">
          <div className="section-title text-center text-lg-start">
            <h4 className="mb-1 theme1">Top Deals</h4>
            <h2 className="mb-1">
              The Last <span className="theme">Minute Deals</span>
            </h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore.
            </p>
          </div>
        </div>
        <div className="col-lg-5" />
      </div>
      <div className="trend-box">
        <div className="row item-slider">
          <div className="col-lg-4">
            <div className="trend-item1 rounded box-shadow bg-white mb-4">
              <div className="trend-image position-relative">
                <img
                  src="images/destination/destination11.jpg"
                  alt="image"
                  className=""
                />
                <div className="trend-content1 p-4">
                  <h5 className="theme1 mb-1">
                    <i className="flaticon-location-pin" /> Norway
                  </h5>
                  <h3 className="mb-1 white">
                    <a href="tour-grid.html" className="white">
                      Norway Lake
                    </a>
                  </h3>
                  <div className="rating-main d-flex align-items-center pb-2">
                    <div className="rating">
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                    </div>
                    <span className="ms-2 white">(16)</span>
                  </div>
                  <div className="entry-meta d-flex align-items-center justify-content-between">
                    <div className="entry-author d-flex align-items-center">
                      <p className="mb-0 white">
                        <span className="theme1 fw-bold fs-5"> $180.00</span> |
                        Per person
                      </p>
                    </div>
                    <div className="entry-author">
                      <i className="icon-calendar white" />
                      <span className="fw-bold white"> 6 Days Tours</span>
                    </div>
                  </div>
                </div>
                <div className="overlay" />
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="trend-item1 rounded box-shadow">
              <div className="trend-image position-relative">
                <img
                  src="images/destination/destination10.jpg"
                  alt="image"
                  className=""
                />
                <div className="trend-content1 p-4">
                  <h5 className="theme1 mb-1">
                    <i className="flaticon-location-pin" /> Usa
                  </h5>
                  <h3 className="mb-1 white">
                    <a href="tour-grid.html" className="white">
                      New York City
                    </a>
                  </h3>
                  <div className="rating-main d-flex align-items-center pb-2">
                    <div className="rating">
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                    </div>
                    <span className="ms-2 white">(12)</span>
                  </div>
                  <div className="entry-meta d-flex align-items-center justify-content-between">
                    <div className="entry-author d-flex align-items-center">
                      <p className="mb-0 white">
                        <span className="theme1 fw-bold fs-5"> $140.00</span> |
                        Per person
                      </p>
                    </div>
                    <div className="entry-author">
                      <i className="icon-calendar white" />
                      <span className="fw-bold white"> 3 Days Tours</span>
                    </div>
                  </div>
                </div>
                <div className="overlay" />
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="trend-item1 rounded box-shadow">
              <div className="trend-image position-relative">
                <img
                  src="images/destination/destination13.jpg"
                  alt="image"
                  className=""
                />
                <div className="trend-content1 p-4">
                  <h5 className="theme1 mb-1">
                    <i className="flaticon-location-pin" /> Maldives
                  </h5>
                  <h3 className="mb-1 white">
                    <a href="tour-grid.html" className="white">
                      Male City
                    </a>
                  </h3>
                  <div className="rating-main d-flex align-items-center pb-2">
                    <div className="rating">
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                    </div>
                    <span className="ms-2 white">(12)</span>
                  </div>
                  <div className="entry-meta d-flex align-items-center justify-content-between">
                    <div className="entry-author d-flex align-items-center">
                      <p className="mb-0 white">
                        <span className="theme1 fw-bold fs-5"> $140.00</span> |
                        Per person
                      </p>
                    </div>
                    <div className="entry-author">
                      <i className="icon-calendar white" />
                      <span className="fw-bold white"> 3 Days Tours</span>
                    </div>
                  </div>
                </div>
                <div className="overlay" />
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="trend-item1 rounded box-shadow">
              <div className="trend-image position-relative">
                <img
                  src="images/destination/destination14.jpg"
                  alt="image"
                  className=""
                />
                <div className="trend-content1 p-4">
                  <h5 className="theme1 mb-1">
                    <i className="flaticon-location-pin" /> Japan
                  </h5>
                  <h3 className="mb-1 white">
                    <a href="tour-grid.html" className="white">
                      Tokyo City
                    </a>
                  </h3>
                  <div className="rating-main d-flex align-items-center pb-2">
                    <div className="rating">
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                      <span className="fa fa-star checked" />
                    </div>
                    <span className="ms-2 white">(10)</span>
                  </div>
                  <div className="entry-meta d-flex align-items-center justify-content-between">
                    <div className="entry-author d-flex align-items-center">
                      <p className="mb-0 white">
                        <span className="theme1 fw-bold fs-5"> $182.00</span> |
                        Per person
                      </p>
                    </div>
                    <div className="entry-author">
                      <i className="icon-calendar white" />
                      <span className="fw-bold white"> 4 Days Tours</span>
                    </div>
                  </div>
                </div>
                <div className="overlay" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* Last Minute Deal Ends */}
  {/* Bucket-list starts */}
  <section className="trending pb-6 pt-0">
    <div className="container">
      <div className="section-title text-center w-75 mx-auto mb-6">
        <h4 className="mb-1 theme1">Bucket List</h4>
        <h2 className="mb-1">
          Top Up Your <span className="theme">Buckect Lists</span>
        </h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore.
        </p>
      </div>
      <div className="trending-topic-main">
        {/* tab navs */}
        <ul
          className="nav nav-tabs nav-pills nav-fill w-50 mx-auto"
          id="postsTab1"
          role="tablist"
        >
          <li className="nav-item" role="presentation">
            <button
              aria-selected="false"
              className="nav-link active"
              data-bs-target="#cycling"
              data-bs-toggle="tab"
              id="cycling-tab"
              role="tab"
              type="button"
            >
              Cycling
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              aria-selected="true"
              className="nav-link"
              data-bs-target="#family"
              data-bs-toggle="tab"
              id="family-tab"
              role="tab"
              type="button"
            >
              Family
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              aria-selected="true"
              className="nav-link"
              data-bs-target="#hiking"
              data-bs-toggle="tab"
              id="hiking-tab"
              role="tab"
              type="button"
            >
              Hiking
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              aria-selected="true"
              className="nav-link"
              data-bs-target="#sailing"
              data-bs-toggle="tab"
              id="sailing-tab"
              role="tab"
              type="button"
            >
              Sailing
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              aria-selected="true"
              className="nav-link"
              data-bs-target="#wildlife"
              data-bs-toggle="tab"
              id="wildlife-tab"
              role="tab"
              type="button"
            >
              Wildlife
            </button>
          </li>
        </ul>
        {/* tab contents */}
        <div className="tab-content pt-4" id="postsTabContent1">
          {/* cycling posts */}
          <div
            aria-labelledby="cycling-tab"
            className="tab-pane fade active show"
            id="cycling"
            role="tabpanel"
          >
            <div className="row">
              <div className="col-lg-6 mb-4">
                <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                  <div className="row m-0">
                    <div className="col-lg-5 col-md-4 ps-0">
                      <div className="trend-item2">
                        <a
                          href="#"
                          style={{
                            backgroundImage:
                              "url(images/trending/trending13.jpg)"
                          }}
                        />
                        <div className="color-overlay" />
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-8">
                      <div className="trend-content py-3 position-relative">
                        <h5 className="theme mb-0">
                          <i className="flaticon-location-pin" /> Croatia
                        </h5>
                        <h3 className="mb-1">
                          <a href="tour-grid.html">Piazza Castello</a>
                        </h3>
                        <div className="trend-meta border-b pb-2 mb-2">
                          <div className="entry-author">
                            <i className="icon-calendar" />
                            <span> 9 Days Tours</span>
                          </div>
                        </div>
                        <div className="entry-meta">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0">
                              <span className="theme fw-bold">
                                {" "}
                                $170.00{" "}
                                <i className="text-decoration-line-through grey fw-normal">
                                  $150.00
                                </i>
                              </span>{" "}
                              | Per person
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mb-4">
                <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                  <div className="row m-0">
                    <div className="col-lg-5 col-md-4 ps-0">
                      <div className="trend-item2">
                        <a
                          href="#"
                          style={{
                            backgroundImage:
                              "url(images/trending/trending12.jpg)"
                          }}
                        />
                        <div className="color-overlay" />
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-8">
                      <div className="trend-content py-3 position-relative">
                        <h5 className="theme mb-0">
                          <i className="flaticon-location-pin" /> Norway
                        </h5>
                        <h3 className="mb-1">
                          <a href="tour-grid.html">Norwale Lake</a>
                        </h3>
                        <div className="trend-meta border-b pb-2 mb-2">
                          <div className="entry-author">
                            <i className="icon-calendar" />
                            <span> 9 Days Tours</span>
                          </div>
                        </div>
                        <div className="entry-meta">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0">
                              <span className="theme fw-bold">
                                {" "}
                                $120.00 | Per person
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mb-4">
                <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                  <div className="row m-0">
                    <div className="col-lg-5 col-md-4 ps-0">
                      <div className="trend-item2">
                        <a
                          href="#"
                          style={{
                            backgroundImage:
                              "url(images/trending/trending11.jpg)"
                          }}
                        />
                        <div className="color-overlay" />
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-8">
                      <div className="trend-content py-3 position-relative">
                        <h5 className="theme mb-0">
                          <i className="flaticon-location-pin" /> Greece
                        </h5>
                        <h3 className="mb-1">
                          <a href="tour-grid.html">Santorini, Oia</a>
                        </h3>
                        <div className="trend-meta border-b pb-2 mb-2">
                          <div className="entry-author">
                            <i className="icon-calendar" />
                            <span> 9 Days Tours</span>
                          </div>
                        </div>
                        <div className="entry-meta">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0">
                              <span className="theme fw-bold">
                                {" "}
                                $80.00 | Per person
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mb-4">
                <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                  <div className="row m-0">
                    <div className="col-lg-5 col-md-4 ps-0">
                      <div className="trend-item2">
                        <a
                          href="#"
                          style={{
                            backgroundImage:
                              "url(images/trending/trending14.jpg)"
                          }}
                        />
                        <div className="color-overlay" />
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-8">
                      <div className="trend-content py-3 position-relative">
                        <h5 className="theme mb-0">
                          <i className="flaticon-location-pin" /> Maldives
                        </h5>
                        <h3 className="mb-1">
                          <a href="tour-grid.html">Hurawalhi Island</a>
                        </h3>
                        <div className="trend-meta border-b pb-2 mb-2">
                          <div className="entry-author">
                            <i className="icon-calendar" />
                            <span> 9 Days Tours</span>
                          </div>
                        </div>
                        <div className="entry-meta">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0">
                              <span className="theme fw-bold">
                                {" "}
                                $170.00{" "}
                                <i className="text-decoration-line-through grey fw-normal">
                                  {" "}
                                  $150.00
                                </i>{" "}
                              </span>{" "}
                              | Per person
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* family posts */}
          <div
            aria-labelledby="family-tab"
            className="tab-pane fade"
            id="family"
            role="tabpanel"
          >
            <div className="row">
              <div className="col-lg-6 mb-4">
                <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                  <div className="row m-0">
                    <div className="col-lg-5 col-md-4 ps-0">
                      <div className="trend-item2">
                        <a
                          href="#"
                          style={{
                            backgroundImage:
                              "url(images/trending/trending1.jpg)"
                          }}
                        />
                        <div className="color-overlay" />
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-8">
                      <div className="trend-content py-3 position-relative">
                        <h5 className="theme mb-0">
                          <i className="flaticon-location-pin" /> Maldives
                        </h5>
                        <h3 className="mb-1">
                          <a href="tour-grid.html">Surf Adventure</a>
                        </h3>
                        <div className="trend-meta border-b pb-2 mb-2">
                          <div className="entry-author">
                            <i className="icon-calendar" />
                            <span> 9 Days Tours</span>
                          </div>
                        </div>
                        <div className="entry-meta">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0">
                              <span className="theme fw-bold">
                                {" "}
                                $120.00 | Per person
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mb-4">
                <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                  <div className="row m-0">
                    <div className="col-lg-5 col-md-4 ps-0">
                      <div className="trend-item2">
                        <a
                          href="#"
                          style={{
                            backgroundImage:
                              "url(images/trending/trending2.jpg)"
                          }}
                        />
                        <div className="color-overlay" />
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-8">
                      <div className="trend-content py-3 position-relative">
                        <h5 className="theme mb-0">
                          <i className="flaticon-location-pin" /> Croatia
                        </h5>
                        <h3 className="mb-1">
                          <a href="tour-grid.html">Piazza Castello</a>
                        </h3>
                        <div className="trend-meta border-b pb-2 mb-2">
                          <div className="entry-author">
                            <i className="icon-calendar" />
                            <span> 9 Days Tours</span>
                          </div>
                        </div>
                        <div className="entry-meta">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0">
                              <span className="theme fw-bold">
                                {" "}
                                $120.00 | Per person
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mb-4">
                <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                  <div className="row m-0">
                    <div className="col-lg-5 col-md-4 ps-0">
                      <div className="trend-item2">
                        <a
                          href="#"
                          style={{
                            backgroundImage:
                              "url(images/trending/trending3.jpg)"
                          }}
                        />
                        <div className="color-overlay" />
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-8">
                      <div className="trend-content py-3 position-relative">
                        <h5 className="theme mb-0">
                          <i className="flaticon-location-pin" /> Maldives
                        </h5>
                        <h3 className="mb-1">
                          <a href="tour-grid.html">Hurawalhi Island</a>
                        </h3>
                        <div className="trend-meta border-b pb-2 mb-2">
                          <div className="entry-author">
                            <i className="icon-calendar" />
                            <span> 9 Days Tours</span>
                          </div>
                        </div>
                        <div className="entry-meta">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0">
                              <span className="theme fw-bold">
                                {" "}
                                $170.00{" "}
                                <i className="text-decoration-line-through grey fw-normal">
                                  $150.00
                                </i>{" "}
                              </span>{" "}
                              | Per person
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mb-4">
                <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                  <div className="row m-0">
                    <div className="col-lg-5 col-md-4 ps-0">
                      <div className="trend-item2">
                        <a
                          href="#"
                          style={{
                            backgroundImage:
                              "url(images/trending/trending4.jpg)"
                          }}
                        />
                        <div className="color-overlay" />
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-8">
                      <div className="trend-content py-3 position-relative">
                        <h5 className="theme mb-0">
                          <i className="flaticon-location-pin" /> Greece
                        </h5>
                        <h3 className="mb-1">
                          <a href="tour-grid.html">Santorini, Oia</a>
                        </h3>
                        <div className="trend-meta border-b pb-2 mb-2">
                          <div className="entry-author">
                            <i className="icon-calendar" />
                            <span> 9 Days Tours</span>
                          </div>
                        </div>
                        <div className="entry-meta">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0">
                              <span className="theme fw-bold">
                                {" "}
                                $120.00 | Per person
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* trending-topic ends */}
  {/* Discount action starts */}
  <section
    className="discount-action pt-0 pb-8"
    style={{
      backgroundImage: "url(images/shape-1.png)",
      backgroundAttachment: "unset"
    }}
  >
    <div className="container">
      <div
        className="call-banner1 rounded"
        style={{
          backgroundImage: "url(images/bg/bg4.jpg)",
          backgroundPosition: "right"
        }}
      >
        <div className="row d-flex align-items-center">
          <div className="col-lg-6 col-md-6 p-0">
            <div className="call-banner-inner bg-theme p-5 pt-10 pb-10 my-5 rounded ms-4">
              <h5 className="mb-1 white">Love Where Your're Going</h5>
              <h2>
                <a href="tour-single.html" className="white">
                  Explore Your Life,{" "}
                  <span className="theme1"> Travel Where You Want!</span>
                </a>
              </h2>
              <p className="white mb-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
                <br />
                <br />
                Excepteur sint occaecat cupidatat non proident, sunt in culpa
                qui officia deserunt mollit anim id est laborum.
              </p>
              <a href="#" className="nir-btn-black">
                Read More
              </a>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 p-0">
            <div className="video-button text-center position-relative z-index2">
              <div className="call-button text-center">
                <button
                  type="button"
                  className="play-btn js-video-button"
                  data-video-id={152879427}
                  data-channel="vimeo"
                >
                  <i className="fa fa-play bg-blue" />
                </button>
              </div>
              <div className="video-figure" />
            </div>
          </div>
        </div>
      </div>
      <div className="partner-wrapper pt-4">
        <div className="row align-items-center text-center text-lg-start">
          <div className="col-lg-2">
            <h3 className="mb-2">Our Partners</h3>
          </div>
          <div className="col-lg-10 mb-2">
            <ul className="side-slider mb-2">
              <li className="p-2 border rounded mx-2 bg-white">
                <img src="images/cl-1.png" alt="" />
              </li>
              <li className="p-2 border rounded mx-2 bg-white">
                <img src="images/cl-2.png" alt="" />
              </li>
              <li className="p-2 border rounded mx-2 bg-white">
                <img src="images/cl-3.png" alt="" />
              </li>
              <li className="p-2 border rounded mx-2 bg-white">
                <img src="images/cl-4.png" alt="" />
              </li>
              <li className="p-2 border rounded mx-2 bg-white">
                <img src="images/cl-5.png" alt="" />
              </li>
              <li className="p-2 border rounded mx-2 bg-white">
                <img src="images/cl-3.png" alt="" />
              </li>
              <li className="p-2 border rounded mx-2 bg-white">
                <img src="images/cl-4.png" alt="" />
              </li>
              <li className="p-2 border rounded mx-2 bg-white">
                <img src="images/cl-5.png" alt="" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* Discount action Ends */}
  {/* our teams starts */}
  <section className="our-team pb-0 pt-0">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-5 mb-4">
          <div className="section-title text-lg-start text-center">
            <h4 className="mb-1 theme1">Tour Guides</h4>
            <h2>
              Meet Our <span className="theme">Excellent Guides</span>
            </h2>
            <p className="mb-2">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
              <br />
              <br />
              Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur.
            </p>
            <a href="#" className="nir-btn">
              View All Guides
            </a>
          </div>
        </div>
        <div className="col-lg-7 mb-4">
          <div className="row team-main">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="team-list bg-white rounded">
                <div className="team-image">
                  <img src="images/team/img1.jpg" alt="team" />
                </div>
                <div className="team-content text-center p-3 bg-theme">
                  <h4 className="mb-0 white">Salmon Thuir</h4>
                  <p className="mb-0 white">Senior Agent</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="team-list bg-white rounded">
                <div className="team-image">
                  <img src="images/team/img2.jpg" alt="team" />
                </div>
                <div className="team-content text-center p-3 bg-theme">
                  <h4 className="mb-0 white">Horke Pels</h4>
                  <p className="mb-0 white">Head Officer</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="team-list bg-white rounded">
                <div className="team-image">
                  <img src="images/team/img4.jpg" alt="team" />
                </div>
                <div className="team-content text-center p-3 bg-theme">
                  <h4 className="mb-0 white">Solden kalos</h4>
                  <p className="mb-0 white">Supervisor</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="team-list bg-white rounded">
                <div className="team-image">
                  <img src="images/team/img3.jpg" alt="team" />
                </div>
                <div className="team-content text-center p-3 bg-theme">
                  <h4 className="mb-0 white">Nelson Bam</h4>
                  <p className="mb-0 white">Quality Assurance</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="team-list bg-white rounded">
                <div className="team-image">
                  <img src="images/team/img1.jpg" alt="team" />
                </div>
                <div className="team-content text-center p-3 bg-theme">
                  <h4 className="mb-0 white">Salmon Thuir</h4>
                  <p className="mb-0 white">Senior Agent</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="team-list bg-white rounded">
                <div className="team-image">
                  <img src="images/team/img2.jpg" alt="team" />
                </div>
                <div className="team-content text-center p-3 bg-theme">
                  <h4 className="mb-0 white">Horke Pels</h4>
                  <p className="mb-0 white">Head Officer</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* our teams Ends */}
  {/* testomonial start */}
  <section
    className="testimonial pt-2 pb-2"
    style={{ backgroundImage: "url(images/testimonial.png)" }}
  >
    <div className="container">
      <div className="section-title mb-6 text-center w-75 mx-auto">
        <h4 className="mb-1 theme1">Our Testimonails</h4>
        <h2 className="mb-1">
          Good Reviews By <span className="theme">Clients</span>
        </h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore.
        </p>
      </div>
      <div className="row align-items-center">
        <div className="col-lg-7 pe-lg-4 mb-4">
          <div className="row review-slider">
            <div className="col-sm-4 item">
              <div className="testimonial-item1 rounded text-lg-start text-center">
                <div className="author-info d-lg-flex align-items-center mb-4">
                  <img src="images/testimonial/img1.jpg" alt="" />
                  <div className="author-title ms-3">
                    <h5 className="m-0 theme">Jared Erondu</h5>
                    <span>Supervisor</span>
                  </div>
                </div>
                <div className="details">
                  <p className="m-0">
                    <i className="fa fa-quote-left me-2 fs-1" />
                    Lorem Ipsum is simply dummy text of the printing
                    andypesetting industry. Lorem ipsum a simple Lorem Ipsum has
                    been the industry's standard dummy hic et quidem.
                    Dignissimos maxime velit unde inventore quasi vero dolorem.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-4 item">
              <div className="testimonial-item1 rounded text-lg-start text-center">
                <div className="author-info d-lg-flex align-items-center mb-4">
                  <img src="images/testimonial/img1.jpg" alt="" />
                  <div className="author-title ms-3">
                    <h5 className="m-0 theme">Jared Erondu</h5>
                    <span>Supervisor</span>
                  </div>
                </div>
                <div className="details">
                  <p className="m-0">
                    <i className="fa fa-quote-left me-2 fs-1" />
                    Lorem Ipsum is simply dummy text of the printing
                    andypesetting industry. Lorem ipsum a simple Lorem Ipsum has
                    been the industry's standard dummy hic et quidem.
                    Dignissimos maxime velit unde inventore quasi vero dolorem.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-5 ps-lg-4 mb-4">
          <div className="testimonial-image text-lg-start text-center">
            <img src="images/testi.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* testimonial ends */}
  {/* recent-articles starts */}
  <section className="trending recent-articles pb-6 pt-0">
    <div className="container">
      <div className="section-title mb-6 w-75 mx-auto text-center">
        <h4 className="mb-1 theme1">Our Blogs Offers</h4>
        <h2 className="mb-1">
          Recent <span className="theme">Articles &amp; Posts</span>
        </h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore.
        </p>
      </div>
      <div className="recent-articles-inner">
        <div className="row">
          <div className="col-lg-4">
            <div className="trend-item box-shadow bg-white mb-4 rounded">
              <div className="trend-image">
                <img src="images/trending/trending10.jpg" alt="image" />
              </div>
              <div className="trend-content-main p-4 pb-2">
                <div className="trend-content">
                  <h5 className="theme mb-1">Technology</h5>
                  <h4>
                    <a href="detail-1.html">
                      How a developer duo at Deutsche Bank keep remote alive.
                    </a>
                  </h4>
                  <p className="mb-3">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod
                  </p>
                  <div className="entry-meta d-flex align-items-center justify-content-between">
                    <div className="entry-author mb-2">
                      <img
                        src="images/reviewer/2.jpg"
                        alt=""
                        className="rounded-circle me-1"
                      />
                      <span>Sollmond Nell</span>
                    </div>
                    <div className="entry-button d-flex align-items-center mb-2">
                      <a href="#" className="nir-btn">
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="trend-item box-shadow bg-white mb-4 rounded">
              <div className="trend-image">
                <img src="images/trending/trending12.jpg" alt="image" />
              </div>
              <div className="trend-content-main p-4 pb-2">
                <div className="trend-content">
                  <h5 className="theme mb-1">Inspiration</h5>
                  <h4>
                    <a href="detail-1.html">
                      Inspire Runner with Autism Graces of Women's Running
                    </a>
                  </h4>
                  <p className="mb-3">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod
                  </p>
                  <div className="entry-meta d-flex align-items-center justify-content-between">
                    <div className="entry-author mb-2">
                      <img
                        src="images/reviewer/1.jpg"
                        alt=""
                        className="rounded-circle me-1"
                      />
                      <span>David Scott</span>
                    </div>
                    <div className="entry-button d-flex align-items-center mb-2">
                      <a href="#" className="nir-btn">
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="trend-item box-shadow bg-white mb-4 rounded">
              <div className="trend-image">
                <img src="images/trending/trending13.jpg" alt="image" />
              </div>
              <div className="trend-content-main p-4 pb-2">
                <div className="trend-content">
                  <h5 className="theme mb-1">Public</h5>
                  <h4>
                    <a href="detail-1.html">
                      Services To Grow Your Business Sell Affiliate Products
                    </a>
                  </h4>
                  <p className="mb-3">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod
                  </p>
                  <div className="entry-meta d-flex align-items-center justify-content-between">
                    <div className="entry-author mb-2">
                      <img
                        src="images/reviewer/3.jpg"
                        alt=""
                        className="rounded-circle me-1"
                      />
                      <span>John Bolden</span>
                    </div>
                    <div className="entry-button d-flex align-items-center mb-2">
                      <a href="#" className="nir-btn">
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* recent-articles ends */}
</>

        <Footer/>
        </>
    )
}